import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Link, Tooltip, Typography } from '@mui/material'
import { createStyles, makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) =>
  createStyles({
    textColor: {
      color: theme.palette.primary.main
    }
  })
)

export const DataGridRowLink = forwardRef(({ href, text, tooltip, placement, enterDelay, enterNextDelay }, ref) => {
  const styleClasses = useStyles()

  const textContainer = tooltip ? (
    <Tooltip ref={ref} title={tooltip} placement={placement} enterDelay={enterDelay} enterNextDelay={enterNextDelay}>
      <span>{text}</span>
    </Tooltip>
  ) : (
    <span>{text}</span>
  )
  return href ? (
    <Link className={`DataGridRowLink ${styleClasses.textColor}`} href={href}>
      {textContainer}
    </Link>
  ) : (
    <Typography className={`DataGridRowLink ${styleClasses.textColor}`}>{textContainer}</Typography>
  )
})

DataGridRowLink.displayName = 'DataGridRowLink'

DataGridRowLink.propTypes = {
  href: PropTypes.string,
  text: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  placement: PropTypes.string,
  enterDelay: PropTypes.number,
  enterNextDelay: PropTypes.number
}

DataGridRowLink.defaultProps = {
  href: null,
  text: '',
  tooltip: null,
  placement: 'right-start',
  enterDelay: 500,
  enterNextDelay: 500
}
